module.exports = __webpack_public_path__ + "img/about-shape2.724fe494.png";